import script from "./MoreMenuLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreMenuLink.vue?vue&type=script&setup=true&lang=ts"

import "./MoreMenuLink.vue?vue&type=style&index=0&id=77e1d37c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e1d37c"]])

export default __exports__